
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function CommonCold(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Common cold"}></DetailHeader>

                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>The common cold is a viral infection of your nose and throat (upper respiratory tract. It's usually harmless, although it might not feel that way. Many types of viruses can cause a common cold.
                                </p>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Common-cold/1.png")} alt="Common-cold" />
                                    </div>
                                </div>
                                <br></br>
                                <p>
                                    <b>Symptoms</b>
                                </p>
                                <p>Symptoms of a common cold usually appear one to three
                                    days after exposure to a cold-causing virus. Signs and
                                    symptoms, which can vary from person to person, might
                                    include:</p>
                                <ul className="listUnstyle">
                                    <li>Runny or stuffy nose</li>
                                    <li>Sore throat</li>
                                    <li>Cough</li>
                                    <li>Congestion</li>
                                    <li>Slight body aches or a mild headache</li>
                                    <li>Sneezing</li>
                                    <li>Low-grade fever</li>
                                    <li>Generally feeling unwell</li>

                                </ul>
                                <p>The discharge from your nose may start out clear and become thicker and
                                    yellow or green as a common cold runs its course. This doesn't usually
                                    mean you have a bacterial infection.</p>
                                <a className="links" href="https://en.wikipedia.org/wiki/Common_cold">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default CommonCold;